/**
 * Настройки устройства, которые должны переживать выход из аккаунта: согласие на cookie, выбранный язык и регион,
 * кэш настроек региона, код доступа тестировщика. Раньше при выходе делался localStorage.clear(), и после каждого
 * входа заново появлялись баннер cookie и запрос языка.
 */
const DEVICE_KEYS = [
    'cookieConsentAccepted',
    'sp_locale',
    'sp_locale_confirmed',
    'i18nextLng',
    'i18n_lang',
    'i18n_user_chosen',
    'user_region',
    'sp_regional_config',
    'sp_tester_code',
    'hasLoggedInBefore',
    'beta_applied',
];

/** Очищает данные сессии и аккаунта, сохраняя настройки устройства. */
export function clearSessionKeepDevicePrefs() {
    const kept = [];
    try {
        DEVICE_KEYS.forEach((key) => {
            const value = localStorage.getItem(key);
            if (value !== null) kept.push([key, value]);
        });
    } catch {
        /* хранилище недоступно */
    }

    try {
        localStorage.clear();
        kept.forEach(([key, value]) => localStorage.setItem(key, value));
    } catch {
        /* хранилище недоступно */
    }
}
